// extracted by mini-css-extract-plugin
export default {"success":"styles_success__cs9tR","danger":"styles_danger__OFOIf"};